import React from 'react';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;
export const DateRange = props => <RangePicker {...props}/>;
export const DateTimePicker = props => <DatePicker {...props}/>;
